var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"o2ositefooter"},[_c('img',{attrs:{"alt":"Cancer Support Community | Gildas Club logos","src":"/images/2022-logo-csc-gildasclub.png"}})])
}]

export { render, staticRenderFns }